import { faMugSaucer } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import Image from "next/image";
import Carousel, { CarouselItem } from "./carousel";

export default function EventsExperiencesOrange () {
  return (
    <section className="mx-auto mt-10 py-4 px-8 bigscreen-responsive">
      <div className="flex justify-center items-center">
        <div className="px-16 text-center">
          <span className="text-white text-md font-bold bg-orange rounded-bl-full rounded-tr-full px-6 py-2">Eventos & Experiencias</span>
          <h2 className="text-center max-w-sm font-thin text-xl mt-8 md:text-3xl md:max-w-3xl">Instalaciones <span className="font-bold">incomparables</span></h2>
          <p className="text-center font-thin py-8 max-w-xs text-md md:max-w-3xl"> Nuestra experiencia en la enseñanza culinaria la trasladamos a la creación de experiencias y eventos a la medida. 
            Somos su mejor aliado para lograr una producción de la mejor calidad con el ingrediente secreto Amura: <span className="font-bold"> el expertise.</span>
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-between items-center gap-8 py-8 md:flex-row">
        <div className="flex flex-col justify-center text-center bg-[#FBF9F2] rounded-[30px] max-w-xs py-2 px-2">
          <div className="rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl py-1 px-1">
            <Carousel items={1} itemsMobile={1} bullets={false} arrows={false} insideBullets={true} nav={false} autoPlay={true} autoPlayInterval={3000}> 
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/cocinas01.jpg" alt="Cocina" width={320} height={176} className="w-80 rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/cocinas02.jpg" alt="Cocina" width={320} height={176} className="w-80 rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/cocinas03.jpg" alt="Cocina" width={320} height={176} className="w-80 rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
            </Carousel>
          </div>
          <div className="pb-4">
            <p className="font-bold text-orange text-md">Cocinas 100% equipadas</p>
            <p className="max-w-xs text-sm px-8 mt-2">Todas nuestras cocinas cuentan con equipos de última generación y tecnología de punta.</p>
          </div>
        </div>
        <div className="flex flex-col justify-center text-center bg-[#FBF9F2] rounded-[30px] max-w-xs py-2 px-2">
          <div className="rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl py-1 px-1">
            <Carousel items={1} itemsMobile={1} bullets={false} arrows={false} insideBullets={true} nav={false} autoPlay={true} autoPlayInterval={3000}> 
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/lab01.jpg" alt="Cocina" width={320} height={176} className="w-full rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/lab02.jpg" alt="Cocina" width={320} height={176} className="w-full rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/lab03.jpg" alt="Cocina" width={320} height={176} className="w-full rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
            </Carousel>
          </div>
          <div className="pb-4">
            <p className="font-bold text-orange text-md">Labs de especialización</p>
            <p className="max-w-xs text-sm px-8 mt-2">Creados para potenciar el aprendizaje y la práctica de nuestros estudiantes.</p>
          </div>
        </div>
        <div className="flex flex-col justify-center text-center bg-[#FBF9F2] rounded-[30px] max-w-xs py-2 px-2">
          <div className="rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl py-1 px-1">
            <Carousel items={1} itemsMobile={1} bullets={false} arrows={false} insideBullets={true} nav={false} autoPlay={true} autoPlayInterval={3000}> 
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/demo01.jpg" alt="Cocina" width={320} height={176} className="w-full rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/demo02.jpg" alt="Cocina" width={320} height={176} className="w-full rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
              <CarouselItem width="0" className="">
                <Image src="/images/instalaciones/demo03.jpg" alt="Cocina" width={320} height={176} className="w-full rounded-tr-[30px] rounded-tl-[30px] rounded-b-xl" quality={70} sizes="(max-width: 768px) 296px, 320px"/>
              </CarouselItem>
            </Carousel>
          </div>
          <div className="pb-4">
            <p className="font-bold text-orange text-md">Aulas demo</p>
            <p className="max-w-xs text-sm px-8 mt-2">Espacios para la demostración y degustación de platillos, productos y técnicas.</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center gap-8 py-4 md:flex-row">
        <div className="flex flex-col justify-center text-left border border-[#FFC93D] rounded-[30px] max-w-xs px-2 py-6">
          <div className="items-center bg-orange rounded-xl py-4 px-4 mx-4 w-16">
            <Image src="/icons/auditorium.svg" alt="Auditorium" width={48} height={32} className="" quality={70}/>
          </div>
          <div className="py-4 px-4">
            <p className="font-bold text-md">Auditorio</p>
            <p className="font-thin text-xs mt-2">CONFERENCIAS • CENAS • EVENTOS • Y MÁS.</p>
            <p className="max-w-xs text-sm mt-2">Espacios para la realización de eventos, conferencias, cenas y más.</p>
          </div>
        </div>
        <div className="flex flex-col justify-center text-left border border-[#FFC93D] rounded-[30px] max-w-xs px-2 py-6">
          <div className="items-center bg-orange rounded-xl py-4 px-3.5 mx-4 w-16">
            <FontAwesomeIcon icon={faMugSaucer} className="text-white text-[28px]"/> 
          </div>
          <div className="py-4 px-4">
            <p className="font-bold text-md">Terraza & cafetería</p>
            <p className="font-thin text-xs mt-2">PARA PRÁCTICAS • AREAS COMUNES • EVENTOS</p>
            <p className="max-w-xs text-sm mt-2">Areas comunes para la realización de prácticas, eventos y áreas de descanso.</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center text-center font-bold py-16">
        <h3 className="text-2xl max-w-lg mb-8">Vení a conocer nuestras instalaciones en persona. ¡Agendá tu cita hoy!</h3>
        <Link href='https://wa.me/50662236864' className="text-white font-bold text-sm rounded-full py-3 px-10 mx-8 shadow-sm bg-gradient-to-r from-orange to-[#FBA919] hover:shadow-lg md:text-nowrap">
          Agendar visita
        </Link>
      </div>
    </section>
  );
}